import { CardActions, CardContent, CardHeader } from "@material-ui/core";
import { DateField, EditButton, FormInput, TextField } from "react-admin";
import React, { Fragment } from "react";

import { compose } from "recompose";
import withCardStyles from "../components/list/withCardStyles";

const Card = ({ classes, ...props }) => (
  <Fragment>
    <CardHeader
      className={classes.header}
      title={<TextField source="name" {...props} variant="subheading" />}
    />
    <CardContent className={classes.content}>
      <FormInput {...props} source="code" input={<TextField addLabel />} />
      <FormInput
        {...props}
        source="profile.name"
        input={<TextField addLabel />}
      />
      <FormInput
        {...props}
        source="modified"
        input={<DateField showTime addLabel />}
      />
    </CardContent>
    <CardActions className={classes.actions}>
      <EditButton {...props} />
    </CardActions>
  </Fragment>
);
export default compose(withCardStyles)(Card);
